import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Layers } from 'lucide-react';

export const Route = createFileRoute('/admin-console/platform-content')({
    staticData: {
        permissions: ['admin_content:read', 'admin_comms:read'],
        breadcrumb: {
            title: 'Platform content',
            inactive: true,
        },
        ui: {
            icon: Layers,
            title: 'Platform content',
            menuDescription: 'Manage platform content and templates',
        },
    },
    component: Outlet,
});
